const era = {}

era.cart = function() {

	// Replace links back to product with links to custom kit
	$('#cart_form .property.kitid').each(function() {
		// Get elements to use
		var $this = $(this);
		var $row = $this.closest('tr');
		var kitID = $this.text().replace('kitid: ', '');

		if (kitID) {
			$row.find('.link-to-product').each(function() {

				var $this = $(this);
				var existingLink = $this.attr('href');
				var newLink = era.addParams(existingLink, { id: kitID });

				$this.attr({
					href: newLink
				});

				// Replace image with preview, if available
				var localImage = localStorage.getItem("kit" + kitID);
				if (localImage) {
					$this.find('img').attr({ src: localImage });
					$this.find('small').remove();
				}

				// Add attribute to cart row
				$this.closest('tr').data({
					kit: kitID
				});

				// Remove thumbnails from local storage if they're not in the cart

				log('localStorage:');
				log(localStorage);

				var filtered_keys = function(obj, filter) {
					var key, keys = [];
					for (key in obj) {
						// if (obj.hasOwnProperty(key) && filter.test(key)) {
						if (Object.prototype.hasOwnProperty.call(obj, key) && filter.test(key)) {
							keys.push(key);
						}
					}
					return keys;
				};

				var filteredNames = filtered_keys(localStorage, /kit\d+$/);
				log(filteredNames);

				$.each(filteredNames, function(key, value) {
					var id = value.replace(/^\D+/g, '');
					if (!$('span.kitid:contains("' + id + '")').length) {
						localStorage.removeItem(value);
					}

				});


			});
		}

	});

	// Remove local storage images when removed from cart
	$('#cart_form .remove a').click(function() {
		var kitID = $(this).closest('tr').data('kit');
		var name = "kit" + kitID;
		localStorage.removeItem(name);
	});

	// List properties when ordered via "Classic" form
	$('#cart_form .property:contains("Form: Classic")').closest('.properties').addClass('show');

};

/**
 * Add to cart function required data format:
 * products: [
 *  {
 * 		 quantity: 1,
 * 		 id: 0000,
 * 		 properties: {
 * 			 "whatever": "whereever",
 * 		 }
 * 	 }	
 *  ]
 */

const addToCart = async (products, goToCart=false) => {
	// Send request
	let response = await fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ items: products }),
	})
	// Parse response
	response = await response.json()
	// Go to the cart, if needed
	if (goToCart) window.location.href = "/cart"
	// Respond
	return response
}

const updateCart = async items => {
	const response = await fetch('/cart/update.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ updates: items })
	})
	return await response.json()
}

export {
	updateCart,
	addToCart,
}
